import { Component, Input, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Paginator } from 'primeng/paginator';
import { yearsList } from 'src/app/core/utils/utils';
import { selectUnitActiveList } from 'src/app/store/unidade/unidade.selectors';

@Component({
  selector: 'split-results-per-month',
  templateUrl: './results-per-month.component.html',
  styleUrls: ['./results-per-month.component.scss']
})
export class ResultsPerMonthComponent {
  @Input() columns: Array<{ percentage: number,data: string, columns: Array<{ valor: any, descricao: any }> }> = [];
  @Input() color = 'rgba(10, 131, 0, 1)';
  @Input() bgColor = '#e6f2e5';
  @Input() header = '';
  @Input() disableResultado = false;
  @Input() breakLine = 'col-12 lg:col-6';
  @Input() enablePaginator = false;
  @Input() results = false
  @Input() receipts = false
  @Input() expensesByCategory = false
  @Input() expenses = false
  @Input() loading = false;

  @Input() subtitle = 'Resultado Real';

  first: number = 0
  monthToMonthResultReportYearFilter: any
  monthToMonthResultChartUnitId: any
  resultFilter: string = 'real'
  UnitsFilterOptions$ = this.store.select(selectUnitActiveList)

  filterYears = this.createFilterYears();
  filterResults = [
    {
      label: 'Real',
      command: () => {
        this.setResultFilterAsReal()
      }
    },
    {
      label: 'Ajustado',
      command: () => {
        this.setResultFilterAsAdjusted()
      }
    }
  ];
  filterUnits = [
    {
      label: 'Vila Nova',
      command: () => {

      }
    },
    {
      label: 'Barreiro',
      command: () => {

      }
    },
    {
      label: 'Belo Horizonte',
      command: () => {

      }
    }
  ];

  expensesArray: any[] = [
    {
      month: '12',
      year: '2023',
      expenses: [
        {
          name: 'Água',
          value: '48.000'
        },
        {
          name: 'Luz',
          value: '40.000'
        },
        {
          name: 'Internet',
          value: '30.000'
        },
        {
          name: 'Aluguel',
          value: '20.000'
        },
        {
          name: 'Repasses Profissionais',
          value: '10.000'
        }
      ]

    },
    {
      month: '11',
      year: '2023',
      expenses: [
        {
          name: 'Água',
          value: '48.000'
        },
        {
          name: 'Luz',
          value: '40.000'
        },
        {
          name: 'Internet',
          value: '30.000'
        },
        {
          name: 'Aluguel',
          value: '20.000'
        },
        {
          name: 'Repasses Profissionais',
          value: '10.000'
        }
      ]

    },
    {
      month: '10',
      year: '2023',
      expenses: [
        {
          name: 'Água',
          value: '48.000'
        },
        {
          name: 'Luz',
          value: '40.000'
        },
        {
          name: 'Internet',
          value: '30.000'
        },
        {
          name: 'Aluguel',
          value: '20.000'
        },
        {
          name: 'Repasses Profissionais',
          value: '10.000'
        }
      ]

    },
    {
      month: '09',
      year: '2023',
      expenses: [
        {
          name: 'Água',
          value: '48.000'
        },
        {
          name: 'Luz',
          value: '40.000'
        },
        {
          name: 'Internet',
          value: '30.000'
        },
        {
          name: 'Aluguel',
          value: '20.000'
        },
        {
          name: 'Repasses Profissionais',
          value: '10.000'
        }
      ]

    },
    {
      month: '08',
      year: '2023',
      expenses: [
        {
          name: 'Água',
          value: '48.000'
        },
        {
          name: 'Luz',
          value: '40.000'
        },
        {
          name: 'Internet',
          value: '30.000'
        },
        {
          name: 'Aluguel',
          value: '20.000'
        },
        {
          name: 'Repasses Profissionais',
          value: '10.000'
        }
      ]

    },
    {
      month: '07',
      year: '2023',
      expenses: [
        {
          name: 'Água',
          value: '48.000'
        },
        {
          name: 'Luz',
          value: '40.000'
        },
        {
          name: 'Internet',
          value: '30.000'
        },
        {
          name: 'Aluguel',
          value: '20.000'
        },
        {
          name: 'Repasses Profissionais',
          value: '10.000'
        }
      ]

    },
    {
      month: '06',
      year: '2023',
      expenses: [
        {
          name: 'Água',
          value: '48.000'
        },
        {
          name: 'Luz',
          value: '40.000'
        },
        {
          name: 'Internet',
          value: '30.000'
        },
        {
          name: 'Aluguel',
          value: '20.000'
        },
        {
          name: 'Repasses Profissionais',
          value: '10.000'
        }
      ]

    },
    {
      month: '05',
      year: '2023',
      expenses: [
        {
          name: 'Água',
          value: '48.000'
        },
        {
          name: 'Luz',
          value: '40.000'
        },
        {
          name: 'Internet',
          value: '30.000'
        },
        {
          name: 'Aluguel',
          value: '20.000'
        },
        {
          name: 'Repasses Profissionais',
          value: '10.000'
        }
      ]

    },
    {
      month: '04',
      year: '2023',
      expenses: [
        {
          name: 'Água',
          value: '48.000'
        },
        {
          name: 'Luz',
          value: '40.000'
        },
        {
          name: 'Internet',
          value: '30.000'
        },
        {
          name: 'Aluguel',
          value: '20.000'
        },
        {
          name: 'Repasses Profissionais',
          value: '10.000'
        }
      ]

    },
    {
      month: '03',
      year: '2023',
      expenses: [
        {
          name: 'Água',
          value: '48.000'
        },
        {
          name: 'Luz',
          value: '40.000'
        },
        {
          name: 'Internet',
          value: '30.000'
        },
        {
          name: 'Aluguel',
          value: '20.000'
        },
        {
          name: 'Repasses Profissionais',
          value: '10.000'
        }
      ]

    },
    {
      month: '02',
      year: '2023',
      expenses: [
        {
          name: 'Água',
          value: '48.000'
        },
        {
          name: 'Luz',
          value: '40.000'
        },
        {
          name: 'Internet',
          value: '30.000'
        },
        {
          name: 'Aluguel',
          value: '20.000'
        },
        {
          name: 'Repasses Profissionais',
          value: '10.000'
        }
      ]

    },
    {
      month: '01',
      year: '2023',
      expenses: [
        {
          name: 'Água',
          value: '48.000'
        },
        {
          name: 'Luz',
          value: '40.000'
        },
        {
          name: 'Internet',
          value: '30.000'
        },
        {
          name: 'Aluguel',
          value: '20.000'
        },
        {
          name: 'Repasses Profissionais',
          value: '10.000'
        }
      ]

    },
  ]

  constructor(private store: Store) {

  }

  createFilterYears(): any {
    return yearsList().map(year => {
      return {
        label: year.toString(),
        command: () => { }
      }
    });
  }
  onPageChange(event: any) {
    this.first = event.first;
}

  setYearFilterMonthToMonthResultReport(event: any) {
    let date = new Date(event)
    console.log("year: ", date.getFullYear())
  }

  resetYearFilterMonthToMonthResultReport() {
    this.monthToMonthResultReportYearFilter = null
  }

  addUnitFilterMonthToMonthResultChart() {
    console.log('unit: ', this.monthToMonthResultChartUnitId)
  }

  setResultFilterAsReal() {
    console.log('real')
    this.resultFilter = 'real'
  }

  setResultFilterAsAdjusted() {
    console.log('ajustado')
    this.resultFilter = 'ajustado'
  }

}
